// extracted by mini-css-extract-plugin
module.exports = {"quote":"quote_quote__1nXRv","title":"quote_title___wu_o"};